import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { AbsoluteWhiteColors } from '@picsart/design-system/foundation/colors';
import { Effects } from '@picsart/design-system/foundation/effects';

const useStyles = createUseStyles(
  {
    actionBar: {
      position: 'relative',
    },
    // Full-width recreate CTA.
    uploadButton: {
      width: '100%',
      height: Spacings.s48,
      borderRadius: CornerRadius.r24,
      background: 'linear-gradient(60.72deg, #0e00ac -11%, #ff34f9 100%)',
      color: AbsoluteWhiteColors.base.default,
    },
    // Column of transparent icon+label actions (Edit, then Save) floating above the
    // CTA, right-aligned. Owning the offset here keeps each button height-agnostic,
    // so showing or hiding one never shifts the other.
    sideRail: {
      position: 'absolute',
      right: 0,
      bottom: `calc(100% + ${Spacings.s16})`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: Spacings.s16,
    },
    railButton: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: Spacings.s4,
      padding: 0,
      border: 'none',
      background: 'none',
      cursor: 'pointer',
      color: AbsoluteWhiteColors.base.default,
    },
    railIcon: {
      width: Spacings.s32,
      height: Spacings.s32,
    },
    railLabel: {
      fontSize: FontSizes.t3,
      fontWeight: FontWeights.medium,
    },
    creditsChip: {
      position: 'absolute',
      left: 0,
      bottom: `calc(100% + ${Spacings.s8})`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: Spacings.s4,
      height: Spacings.s32,
      padding: `0 ${Spacings.s12}`,
      borderRadius: CornerRadius.r32,
      backgroundColor: Effects.alpha20,
      color: AbsoluteWhiteColors.base.default,
      fontSize: FontSizes.t4,
      fontWeight: FontWeights.medium,
      pointerEvents: 'none',
    },
    creditsIcon: {
      width: Spacings.s16,
      height: Spacings.s16,
    },
  },
  { name: 'feed-action-bar' }
);

export default useStyles;
